import * as React from 'react'
import { CategoryProvider, CategoryProviderProps } from './category/provider'
import { TagInitializer } from './initialiser'
import { TagLoader } from './loader'
import "./styles.scss"
import { TagProvider, TagProviderProps } from './tag/provider'


export type TagProps = React.PropsWithChildren<Partial<{

    tags: TagProviderProps,
    categories: CategoryProviderProps

}>>


export const Tags = (props: TagProps) => {

    const { children, tags, categories } = props

    return <TagProvider {...tags}>
        <CategoryProvider {...categories}>
            <TagInitializer />
            <TagLoader>
                {children}
            </TagLoader>
        </CategoryProvider>
    </TagProvider>


}
